/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayNarrativePointDtoSchema } from "./replayNarrativePointDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayTeamNarrativeDtoSchema = z.object({
  side: z.string().nullish(),
  win: z.optional(z.boolean()),
  get points() {
    return z.array(goodLuckCoreDTOsReplayNarrativePointDtoSchema).nullish();
  },
});
